import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { BeginDiscordOAuthInput_InputAdapter_instance2cer7e6l955ce as BeginDiscordOAuthInput_InputAdapter_instance } from '../type/adapter/BeginDiscordOAuthInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BeginDiscordOAuthMutation_VariablesAdapterClass;
function BeginDiscordOAuthMutation_VariablesAdapter() {
  if (BeginDiscordOAuthMutation_VariablesAdapterClass === VOID) {
    class $ {
      n6h(writer, value, customScalarAdapters, withDefaultValues) {
        writer.l4d('input');
        obj(BeginDiscordOAuthInput_InputAdapter_instance).q40(writer, customScalarAdapters, value.k6h_1);
      }
    }
    initMetadataForObject($, 'BeginDiscordOAuthMutation_VariablesAdapter');
    BeginDiscordOAuthMutation_VariablesAdapterClass = $;
  }
  return BeginDiscordOAuthMutation_VariablesAdapterClass;
}
var BeginDiscordOAuthMutation_VariablesAdapter_instance;
function BeginDiscordOAuthMutation_VariablesAdapter_getInstance() {
  return BeginDiscordOAuthMutation_VariablesAdapter_instance;
}
//region block: init
BeginDiscordOAuthMutation_VariablesAdapter_instance = new (BeginDiscordOAuthMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  BeginDiscordOAuthMutation_VariablesAdapter_instance as BeginDiscordOAuthMutation_VariablesAdapter_instance3gwtd23afv9v6,
};
//endregion

//# sourceMappingURL=BeginDiscordOAuthMutation_VariablesAdapter.mjs.map
